import styled from 'react-emotion'

const TableRow = styled('tr')({
    background: '#fff',
    boxShadow: '0 15px 35px rgba(50,50,93,0.1), 0 5px 15px rgba(0,0,0,0.07)',
    transition: 'all 250ms',
    'td:first-child': {
        borderTopLeftRadius: 4,
        borderBottomLeftRadius: 4
    },
    'td:last-child': {
        borderTopRightRadius: 4,
        borderBottomRightRadius: 4
    },
    '@media (min-width: 501px)': {
        ':hover': {
            cursor: 'pointer',
            transform: 'scale(1.04)'
        },
    },
    '@media (max-width: 320px)': {
        'td:nth-child(3)': {
            display: 'none'
        }
    }
})

export default TableRow


// WEBPACK FOOTER //
// ./src/components/TableRowComponent.jsx